<template>
  <div>
    <el-tabs
        v-model="activeIndexTab"
        type="card"
        @tab-click="clickTab"
        @tab-remove="removeTab"
        @contextmenu.native.prevent="openContextmenu"
    >
      <el-tab-pane
          v-for="(item, index) of openTab"
          :v-if="openTab.length"
          :data-index="index"
          :key="item.name"
          :closable="item.closeFlg"
          class="myTab"
          :label="item.name"
          :name="item.path"
      />
    </el-tabs>
    <!-- 右边菜单 -->
    <ul
        v-show="visible"
        :style="{ left: left + 'px', top: '90px' }"
        class="contextmenu"
    >
<!--            <li @click="refreshTags">刷新</li>-->
      <li @click="closeSelectedTag" v-if="this.selectedTag!='系统首页'">关闭当前</li>
      <li @click="closeAllTags">关闭所有</li>
      <li @click="closeOthersTags">关闭其他</li>

    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      left: 0,
      visible: false,
      selectedTag: '',
    }
  },
  computed: {
    activeIndexTab: {
      get() {
        return this.$store.state.app.activeIndexTab
      },
      set(newValue) {
        return newValue
      }
    },
    openTab() {
      return this.$store.state.app.openTab
    }
  },
  watch: {
    $route: {
      handler(newValue) {
        this.openTab[0]={
          path: '/home',
          name: '系统首页',
          closeFlg: false,
        };
        let flag = false
        this.openTab.forEach((item) => {
          if (item.path === newValue.path) {
            flag = true
            this.$store.commit('app/setActiveIndexTab', newValue.path)
          }
        })
        if (!flag) {
          let closes = true;
          if (newValue.meta.title == '系统首页') {
            closes = false;
          }
          this.$store.commit('app/setOpenTab', {
            path: newValue.path,
            name: newValue.meta.title,
            closeFlg: closes,
          })
          this.$store.commit('app/setActiveIndexTab', newValue.path)
        }
      },
      immediate: true
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!e.target.className.includes('el-tabs')) {
        this.visible = false
      }
    })
  },
  methods: {
    refreshTags() {

    },
    closeAllTags() {
      if (this.visible) {
        this.$store.commit('app/closeAll', [
          // this.openTab[this.openTab.length - 1]
          this.openTab[0]
        ])
        this.visible = false
        this.$router.push({path: this.activeIndexTab})
      }
    },
    closeSelectedTag() {
      if (this.openTab.length === 1) {
        return
      }
      if (this.visible) {
        this.$store.commit('app/closeSelected', this.activeIndexTab)
        this.visible = false
        this.$router.push({path: this.activeIndexTab})

      }
    },
    closeOthersTags() {
      if (this.visible) {
        this.$store.commit('app/closeOthers',
            this.activeIndexTab)
        this.visible = false
        this.$router.push({path: this.activeIndexTab})
      }
    },
    openContextmenu(e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      if (this.visible) {
        this.visible = !this.visible
      } else {
        this.visible = true
        this.selectedTag = e.target.innerText
      }
    },
    clickTab(currentTab) {
      this.$router.push({path: currentTab.name})
    },
    removeTab(target) {
      if (this.openTab.length === 1) {
        return
      }
      this.$store.commit('app/deleteOpenTab', target)
      this.$router.push({path: this.activeIndexTab})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none !important;
  border-left: none !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: none !important;
  border-left: none !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}

::v-deep .el-tabs__nav {
  background: #fff;
}

::v-deep .is-active {
  color: #ffffff;
  background-color: #5111ee;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #eee;
    }
  }
}
</style>


